// extracted by mini-css-extract-plugin
export default {"title":"PLb7uZd3Jhg9iaQAHCTj"};